import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import img1 from "../assets/m_bunbury1.jpg";
import img2 from "../assets/m_heroes1.jpg";
import img3 from "../assets/m_jaguares1.jpg";
import img4 from "../assets/m_jumbo1.jpg";
import img5 from "../assets/m_laley1.jpg";
import img6 from "../assets/m_revolver1.jpg";
import img7 from "../assets/m_robirosa1.jpg";
import config from "../config";

const MusicStyle = styled.div`
  flex: 1;
  padding: 10px;
`;

const MusicItem = styled.div`
  margin-left: 20px;
`;

const StyledList = styled.ul`
  list-style-type: none;
  padding-left: 20px;
`;

const Music = () => {
  const [musicData, setMusicData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [previousState, setPreviousState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  useEffect(() => {
    fetch(`${config.API_BASE_URL}/music`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setMusicData(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setLoadingError(true);
      });
  }, []);

  const handleClick = (artistId, albumId, songId) => {
    setPreviousState({ musicData });
    const idFormat = `${artistId}-${albumId}-${songId}`;
    setLoading(true);
    setLoadingError(false);
    
    fetch(`${config.API_BASE_URL}/music/${idFormat}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (songId > 0) {
          setSelectedItem({
            type: "song",
            idFormat,
            artistName: data.artist_name,
            songTitle: data.song_title,
            songLyrics: data.song_lyrics.replace(/\\r\\n|\\r|\\n/g, "<br/>")
          });
        } else {
          setSelectedItem({
            type: "album",
            idFormat,
            artistName: data.artist_name,
            albumTitle: data.album_title,
            albumYear: data.album_year,
            albumImage: data.album_image,
            artistOrigin: data.artist_origin,
            artistDesc: data.artist_desc,
            artistWebsite: data.artist_www,
            songs: data.songs
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setLoadingError(true);
      });
  };

  const handleBack = () => {
    setSelectedItem(null);
    if (previousState) {
      setMusicData(previousState.musicData);
      setPreviousState(null);
    }
  };

  return (
    <MusicStyle>
    {selectedItem ? (
      <div>
        <div align="left"><a href="#" onClick={handleBack}>powrót</a></div><br/>
        {selectedItem.type === "song" ? (
            <>
              <h5>{selectedItem.artistName} - {selectedItem.songTitle}</h5>
              <p dangerouslySetInnerHTML={{ __html: selectedItem.songLyrics }}></p>
            </>
          ) : (
            <>
              <h5>{selectedItem.artistName} - "{selectedItem.albumTitle}" {selectedItem.albumYear}</h5>
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                {selectedItem.albumImage && <img src={`../assets/${selectedItem.albumImage}`} alt={selectedItem.albumTitle} style={{ marginRight: "10px" }} />}
                <div>
                  {selectedItem.artistOrigin && <p>Nacionalidad: {selectedItem.artistOrigin}</p>}
                  {selectedItem.artistDesc && <p>{selectedItem.artistDesc}</p>}
                  {selectedItem.artistWebsite && <p><a href={selectedItem.artistWebsite} target="_blank" rel="noopener noreferrer">{selectedItem.artistWebsite}</a></p>}
                </div>
              </div>
                {selectedItem.songs.map((song, index) => (
                  <>
                  <br/>
                  <b>{song.song_id}</b>
                  <p dangerouslySetInnerHTML={{ __html: song.song_lyrics.replace(/\\r\\n|\\r|\\n/g, "<br>") }}></p>
                  </>
                ))}
            </>
          )}
        </div>
    ) : (
      <>
      <h5>Muzyka</h5>
      <div>
        <p>Poniżej można znaleźć hiszpańskie teksty do mniej lub bardziej popularnych piosenek. Obecnie w bazie znajduje się 140 tekstów piosenek 36 artystów, w tym 7 albumów.</p>
        
        {loading ? (
          <p><b>Dane są ładowane ...</b></p>
        ) : loadingError ? (
          <p><b>Przepraszamy, wystąpił problem przy wczytywaniu</b></p>
        ) : (
          <ul>
            {musicData.map((artist) => (
              <>
              <li key={artist.artist_id}>
                <b>{artist.artist_name}</b>
                <MusicItem>
                  {artist.albums.map((album) => (
                    <li key={album.album_id}><a href="#" onClick={() => handleClick(artist.artist_id, album.album_id, 0)}><b>{album.album_title}</b> (album)</a></li>
                  ))}
                  {artist.songs.map((song) => (
                    <li key={song.song_id}><a href="#" onClick={() => handleClick(artist.artist_id, 0, song.song_id)}>{song.song_title}</a></li>
                  ))}
                </MusicItem>
              </li>
              <br/>
              </>
            ))}
          </ul>
          )}
      </div>
      </>
    )}
    </MusicStyle>
  );
};

export default Music;